module.exports = __webpack_public_path__ + "static/media/more.fcd9c47f.svg";